import { defineStore } from 'pinia';

export const useConnectivityStore = defineStore('connectivity', {
  state: () => ({
    // Default online so SSR and the first client paint never flash the toast.
    // The connectivity client plugin sets the real value on mount.
    isOnline: true,
    // Bumped whenever the user attempts an action that is blocked while offline,
    // so the toast can pulse to acknowledge the attempt.
    flash: 0,
  }),
  actions: {
    setOnline(value) {
      this.isOnline = value;
    },
    notifyBlocked() {
      this.flash++;
    },
  },
});
